<template>
  <v-dialog :value="openFilter" persistent max-width="570">
    <v-card>
      <v-card-title>Filter</v-card-title>

      <v-card-text>

        <v-row>
          <v-col>
            <v-select v-model="filters.status__in" :items="status" label="Status" dense outlined multiple></v-select>
          </v-col>

          <v-col>
            <v-menu ref="menu1" v-model="createdMenu" :close-on-content-click="false" :return-value.sync="created" transition="scale-transition" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :value="createdDateRange" label="Created" readonly dense outlined v-bind="attrs" v-on="on" :error-messages="dateRangeCreatedError" @input="$v.created.$touch()"
                  @blur="$v.created.$touch()"></v-text-field>
              </template>

              <v-date-picker v-model="created" range no-title width="400px">
                <v-btn color="warning" small outlined @click="clearCreatedCalendar">CLEAR</v-btn>

                <v-spacer></v-spacer>

                <v-btn color="primary" small @click="saveCreatedCalendar">Ok</v-btn>
                <v-btn color="primary" small class="ml-3" outlined @click="createdMenu = false;">Cancel</v-btn>
              </v-date-picker>

            </v-menu>
          </v-col>
        </v-row>
        
        <v-row>
          <v-col>
            <v-select v-model="filters.agent_sid" :items="agents" label="Agent" dense outlined hide-details></v-select>
          </v-col>

          <v-col>
            <v-menu ref="menu2" v-model="closedMenu" :close-on-content-click="false" :return-value.sync="closed" transition="scale-transition" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :value="closedDateRange" label="Closed" readonly dense outlined v-bind="attrs" v-on="on" :error-messages="dateRangeClosedError" @input="$v.closed.$touch()"
                  @blur="$v.closed.$touch()"></v-text-field>
              </template>

              <v-date-picker v-model="closed" range no-title width="400px">
                <v-btn color="warning" small outlined @click="clearClosedCalendar">CLEAR</v-btn>

                <v-spacer></v-spacer>

                <v-btn color="primary" small @click="saveClosedCalendar">Ok</v-btn>
                <v-btn color="primary" small class="ml-3" outlined @click="closedMenu = false;">Cancel</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      
        <v-row>
          <v-col>
            <v-radio-group v-model="filters.transfers" row hide-details class="mt-0">
              <v-radio label="Include Transfers" value="include"></v-radio>
              <v-radio label="Exclude Transfers" value="exclude"></v-radio>
              <v-radio label="Transfers Only" value="only"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
          
        <v-row class="mb-3">
          <v-col class="d-flex justify-start">
            <v-checkbox v-model="filters.contains_voip" label="VoIP" hide-details class="mt-0"></v-checkbox>
            <v-checkbox v-model="filters.contains_telco" label="Telco" hide-details class="mt-0 mx-3"></v-checkbox>
            <v-checkbox v-model="filters.contains_websites" label="Websites" hide-details class="mt-0"></v-checkbox>
          </v-col>
        </v-row>

        <v-row class="mb-3">
          <v-col class="d-flex justify-start">
            <v-checkbox v-model="filters.no_contact" label="No Contact" hide-details class="mt-0"></v-checkbox>
          </v-col>
        </v-row>

      </v-card-text>

      <v-divider></v-divider>
      
      <v-card-actions>
        <v-btn color="warning" small outlined @click="clearFilters">Clear</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="filterLeads">Filter</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { minLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  mixins: [validationMixin],

  validations: {
    created: { minLength: minLength(2) },
    closed: { minLength: minLength(2) },
  },

  props: {
    openFilter: {
      type: Boolean,
      default: false,
    },

    agents: {
      type: Array,
      default: () => ([]),
    }
  },

  data() {
    return {
      status: ["New", "Open", "Closed"],
      createdMenu: false,
      closedMenu: false,
      created: [],
      closed: [],
      filters: {
        status__in: [],
        transfers: null,
        agent_sid: null,
        contains_telco: null,
        contains_voip: null,
        contains_websites: null,
        no_contact: null,
      }
    }
  },

  watch: {
    async openFilter(val) {
      if(val){
        this.filters.status__in = this.getRetentionConfigs.queryParams.status__in;
        this.filters.transfers = this.getRetentionConfigs.queryParams.transfers;
        this.filters.agent_sid = this.getRetentionConfigs.queryParams.agent_sid;
        this.filters.contains_telco = this.getRetentionConfigs.queryParams.contains_telco;
        this.filters.contains_voip = this.getRetentionConfigs.queryParams.contains_voip;
        this.filters.contains_websites = this.getRetentionConfigs.queryParams.contains_websites;
        this.filters.no_contact = this.getRetentionConfigs.queryParams.no_contact;

        if(this.getRetentionConfigs.queryParams.creation_timestamp__gte && this.getRetentionConfigs.queryParams.creation_timestamp__lte) {
          this.created = [moment(this.getRetentionConfigs.queryParams.creation_timestamp__gte).format("YYYY-MM-DD"), moment(this.getRetentionConfigs.queryParams.creation_timestamp__lte).format("YYYY-MM-DD")];
        } else {
          this.created = [];
        }

        if(this.getRetentionConfigs.queryParams.closed_timestamp__gte && this.getRetentionConfigs.queryParams.closed_timestamp__lte) {
          this.created = [moment(this.getRetentionConfigs.queryParams.closed_timestamp__gte).format("YYYY-MM-DD"), moment(this.getRetentionConfigs.queryParams.closed_timestamp__lte).format("YYYY-MM-DD")];
        } else {
          this.closed = [];
        }
      }
    },
  },

  computed: {
    ...mapGetters("retention", ["getRetentionConfigs"]),

    dateRangeCreatedError() {
      const errors = [];
      if(!this.$v.created.$dirty) return errors;
      !this.$v.created.minLength && errors.push("Created: requires a date range to be selected.");
      return errors;
    },

    dateRangeClosedError() {
      const errors = [];
      if(!this.$v.created.$dirty) return errors;
      !this.$v.closed.minLength && errors.push("Closed: requires a date range to be selected.");
      return errors;
    },

    createdDateRange () {
      return this.created.sort().join(' - ');
    },

    closedDateRange () {
      return this.closed.sort().join(' - ');
    },
  },

  methods: {
    ...mapActions("retention", ["getRetentionAgents", "loadRetentionLeads", "updateRetentionPagination","downloadExportByFilter"]),

    filterLeads() {
     this.$v.$touch();

      if(!this.$v.$invalid) {
        this.filters.page = 1;

        this.updateRetentionPagination({ 
          queryParams: {
            ...this.filters,
            creation_timestamp__gte: this.created[0] ? `${this.created[0]}T00:00:00` : null,
            creation_timestamp__lte: this.created[1] ? `${this.created[1]}T23:59:59` : null,
            closed_timestamp__gte: this.closed[0] ? `${this.closed[0]}T00:00:00` : null,
            closed_timestamp__lte: this.closed[1] ? `${this.closed[1]}T23:59:59` : null,
          }
        });

        this.closeDialog();
      }
    },

    clearFilters() {
      this.filters.status__in = ["New"];
      this.filters.agent_sid = null;
      this.filters.transfers = 'include';
      this.filters.contains_voip = false;
      this.filters.contains_telco  = false;
      this.filters.contains_websites = false;
      this.filters.no_contact = false;
      this.createdMenu = false;
      this.closedMenu = false;
      this.created = [];
      this.closed = [];
    },

    saveCreatedCalendar() {
      if (this.created.length !== 0 ) {
        this.created.sort();
      }

      this.$refs.menu1.save(this.created);
    },

    clearCreatedCalendar() {
      this.created = [];
      this.saveCreatedCalendar();
    },

    saveClosedCalendar() {
      if (this.closed.length !== 0 ) {
        this.closed.sort();
      }

      this.$refs.menu2.save(this.closed);
    },

    clearClosedCalendar() {
      this.closed = [];
      this.saveClosedCalendar();
    },

    closeDialog() {
      this.$emit('closeDialog');
    },
  }
}
</script>

<style>

</style>